import { useEffect, useState } from 'react';

export const DEFAULT_DEBOUNCE_DELAY_MS = 300;

const useDebouncedValue = (value, delay = DEFAULT_DEBOUNCE_DELAY_MS) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (delay <= 0) {
      setDebouncedValue(value);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => window.clearTimeout(timeoutId);
  }, [delay, value]);

  return debouncedValue;
};

export default useDebouncedValue;
